export default __webpack_public_path__ + "static/media/Q3 with CNBC TV18 yt.4f9f5c75.png";